import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "cssBoxShadow", "cssScrollSnapAlign", "cssEmpty"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "PPUIGridItem__StyledDiv"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const PPUIGridItem = _ref => {
  let {
      as,
      children,
      cssBoxShadow,
      cssScrollSnapAlign,
      cssEmpty
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const boxShadow = cssBoxShadow !== null && cssBoxShadow !== void 0 ? cssBoxShadow : cssStyles.boxShadow;
  const emptyStyles = {
    ':empty': cssEmpty
  };
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({
    as: as
  }, domProps, callbackProps, {
    $cssStyles: Object.assign({}, cssStyles, {
      boxShadow,
      scrollSnapAlign: cssScrollSnapAlign
    }, emptyStyles),
    children: children
  }));
};